import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective } from '@ng-select/ng-select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ICreateSubRouteItinerary } from '../../sub-routes/sub-route-itinerary/interfaces/create-route-itinerary.interface';
import { RouteItineraryService } from '../../route/route-itinerary/route-itinerary.service';
import { FrecuencyModalComponent } from '../../sub-routes/sub-route-delivery-times/frecuency/frecuency.component';
import { AssignDateModalComponent } from './assign-date/assign-date.component';
import ItineraryAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route/itinerary-route/itinerary.entity';
import { ActionModalComponent } from './route-itinerary-action/route-itinerary-action.component';
import { ItineraryActionEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/itinerary-action.enum';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslocoModule } from '@ngneat/transloco';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { forkJoin } from 'rxjs';
import { RoutingItineraryAttributes, RoutingItineraryDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { ICreateRoutingItinerary } from '../../routing-itinerary/interfaces/create-routing-itinerary.interface';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { RoutingItineraryService } from '../../routing-itinerary/routing-itinerary.service';
import { RoutingItineraryTypesEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/routing-itinerary-types.enum";
import { RoutingItinerary } from '../../routing-itinerary/routing-itinerary.component';
import { DeleteConfirmationComponent } from 'app/modules/components/business-partners/business-partner/delete-modal/delete-modal.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-add-route-itinerary-modal',
  styleUrl: './route-itinerary.component.scss',
  templateUrl: './route-itinerary.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatIconModule,
    FormsModule,
    NgLabelTemplateDirective,
    MatSlideToggle,
    MatTableModule,
    FormatOtherDateHourPipe,
    TranslocoModule,
    MatTabsModule,
    MatChipsModule,
    DragDropModule,
  ],
})
export class RouteGroupItinerary {

  openFormAdd = false  

  listCollaboratorsAdd:ItineraryAttributes[] = []

  //currentCreateSubRouteCollaborator: ICreateSubRouteDeliveryTimes = this.initializeCreateSubRouteCollaborator();
  currentUpdateRouteItinerary: ItineraryAttributes | undefined;
  currentCreateRouteItinerary: ICreateSubRouteItinerary = this.initializeCreateSubRouteItinerary();
  
  //v2
  displayedColumnsI: string[] = ["days", "action", 
    "status", "actions"];
  daysList: { day: string; value: number }[] = [
    { day: 'LUNES', value: 1 },
    { day: 'MARTES', value: 2 },
    { day: 'MIÉRCOLES', value: 3 },
    { day: 'JUEVES', value: 4 },
    { day: 'VIERNES', value: 5 },
    { day: 'SÁBADO', value: 6 },
    { day: 'DOMINGO', value: 7 }
  ];
  actionsItinerary: ItineraryActionEnum[] = []
  isAddingItinerary: boolean = false

  filter = {
    dateini: new Date(),
    dateend: new Date(),
  };

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  //Itinerario
  displayedColumnsI2: string[] = ['det', "datetimeStart", "datetimeEnd", "status", "actions"];
  dataSourceItinerary = new MatTableDataSource<RoutingItineraryAttributes>([]);

  selectedItinerary: RoutingItineraryAttributes | null = null;

  displayedColumnsID2: string [] = ['days', 'action', 'actions'];
  listItineraryDetail: RoutingItineraryDetailAttributes[] = []

  currentCreateRoutingItinerary: ICreateRoutingItinerary = this.initializeCreateSubRouteItineraryV2();
  currentCreateRoutingItineraryDay: number = null;
  currentCreateRoutingItineraryActions: ItineraryActionEnum[] = [];
  
  openFormAddRoutingItineraryDetail = false;  
  editDetailRoutingItineraryDetail = false;

  //Itinerario Alternativo
  dataSourceItineraryAlternative = new MatTableDataSource<RoutingItineraryAttributes>([]);
  selectedItineraryAlternative: RoutingItineraryAttributes | null = null;

  listItineraryAlternativeDetail: RoutingItineraryDetailAttributes[] = []

  openFormAddRoutingItineraryAlternativeDetail = false;  
  editDetailRoutingItineraryAlternativeDetail = false;

  currentCreateRoutingItineraryAlternative: ICreateRoutingItinerary = this.initializeCreateSubRouteItineraryV2();
  currentCreateRoutingItineraryAlternativeDay: number = null;
  currentCreateRoutingItineraryAlternativeActions: ItineraryActionEnum[] = [];

  constructor(
    private dialog: MatDialog,
    private readonly routingItineraryService: RoutingItineraryService,

    public dialogRef: MatDialogRef<RouteGroupItinerary>,
    private snackBar: MatSnackBar,  

    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) {
    this.actionsItinerary = Object.values(ItineraryActionEnum);
  }

  ngAfterViewInit(): void {
    //this.getListRouteGroupItinerary();
    this.getRoutingItineraryByType('ROUTE_GROUP');
    this.getRoutingItineraryByType('ROUTE_GROUP_ALTERNATIVE');
  }

  /*getListRouteGroupItinerary() {
    this.routingItineraryService.findBySubRouteIdAndType(this.data._id.toString(), RoutingItineraryTypesEnum.ROUTE_GROUP)
    .subscribe((data) => {
      this.dataSourceItinerary.data = data?.data;
    });
  }*/

  getRoutingItineraryByType(type: string) {
    this.routingItineraryService
    .findBySubRouteIdAndType(this.data._id.toString(), type)
    .subscribe((data) => {
      switch (type) {
        case 'ROUTE_GROUP':
          this.dataSourceItinerary.data = data?.data;
          break;
        case 'ROUTE_GROUP_ALTERNATIVE':
          this.dataSourceItineraryAlternative.data = data?.data;
          break;
        default:
          break;
      }
    });
  }

  private initializeCreateSubRouteItinerary(): ICreateSubRouteItinerary {
    return {
        days: [],
        action: [],
        datetimeStart: new Date(),
        datetimeEnd: new Date(),
    };
  }

  submitForm() {
    this.currentCreateRouteItinerary.datetimeStart = this.range.value.start;
    this.currentCreateRouteItinerary.datetimeEnd = this.range.value.end;
  }

  /*
  onAddToListDeliveryTimes() {
    this.submitForm()
    if(this.currentCreateRouteItinerary.days.length == 0 && this.currentCreateRouteItinerary.action.length == 0){
      this.snackBar.open("Faltan campos a seleccionar", "Cerrar", {duration: 5000,verticalPosition: "top",});
      return;
    }

    if (!this.isValidItineraryActions(this.currentCreateRouteItinerary.action)) {
      this.snackBar.open("El orden de las acciones seleccionadas no es válido", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
      return;
    }
    
    const requests = this.currentCreateRouteItinerary.days.map(day => {
      const itinerary = { ...this.currentCreateRouteItinerary, days: [day] };
      //return this.createItinerary(itinerary);
    }).filter(req => req !== null);
    
    forkJoin(requests).subscribe({
      next: () => {
        this.snackBar.open("Registro(s) creado(s) con éxito", "Cerrar", { duration: 5000, verticalPosition: "top" });
        this.getListRouteGroupItinerary();
        
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al crear el registro", "Cerrar", { duration: 5000, verticalPosition: "top" });
      },
      complete: () => {
        this.isAddingItinerary = false;
        this.currentCreateRouteItinerary = this.initializeCreateSubRouteItinerary();
      }
    });
  }*/

  isValidItineraryActions(actions: ItineraryActionEnum[]): boolean {
    if(actions.length == 1){
      return true;
    }

    const requiredOrder = [
      ItineraryActionEnum.CHARGE,
      ItineraryActionEnum.START_TRIP,
      ItineraryActionEnum.IN_TRIP,
      ItineraryActionEnum.RETURN
    ];
  
    const filteredActions = requiredOrder.filter(action => actions.includes(action));
  
    // 1. Verifica si el orden de las acciones es correcto
    if (JSON.stringify(filteredActions) !== JSON.stringify(actions)) {
      return false;
    }

    // 2. Si se selecciona RETURN, debe incluir START_TRIP e IN_TRIP
    if (actions.includes(ItineraryActionEnum.RETURN)) {
      if (!actions.includes(ItineraryActionEnum.START_TRIP) || !actions.includes(ItineraryActionEnum.IN_TRIP)) {
        return false;
      }
    }

    return true;
  }

  onStatusChange(event: boolean, element){
    const updatedStatusId = event ? 1 : 0;
    element.statusId = updatedStatusId;
  }

  onUpdateDeliveryTime(element, i){
    element.isEditMode = true;
  }

  onSaveDeliveryTime(element, i){
    if(element.days.length == 0 || element.action.length == 0){
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    if (!this.isValidItineraryActions(element.action)) {
      this.snackBar.open("El orden de las acciones seleccionadas no es válido", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
      return;
    }

    element.isEditMode = false;

    /*this.itineraryService.updateEmbedded(this.data._id, element._id, element).subscribe({
      next: () => {
        this.snackBar.open("Itinerario actualizado con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.getListRouteGroupItinerary()
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el Itinerario",
          "Cerrar",
          { duration: 5000, verticalPosition: "top" }
        );
      },
    })*/
  }

  onDeleteDeliveryTime(element, i) {
    /*this.itineraryService.deleteEmbedded1d(this.data._id, element._id).subscribe({
      next: () => {
        this.snackBar.open("Itinerario eliminado con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.getListRouteGroupItinerary()
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al eliminar el Itinerario",
          "Cerrar",
          { duration: 5000, verticalPosition: "top" }
        );
      },
    })*/
  }

  openDatePickerModal(action:string, data?:ItineraryAttributes){
    const dialogRef = this.dialog.open(AssignDateModalComponent, {
      panelClass: ".form-modal-interlocutor",
      data: action == 'create' ? this.currentCreateRouteItinerary : data,
      width: "500px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(action == 'create'){
          this.currentCreateRouteItinerary = result;
        }else{
          data = result;
        }
      }
    })
  }

  openFrecuencyModal(action:string, data?:ItineraryAttributes){
    const dialogRef = this.dialog.open(FrecuencyModalComponent, {
      panelClass: ".form-modal-interlocutor",
      data: action == 'create' ? this.currentCreateRouteItinerary : data,
      width: "500px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(action == 'create'){
        this.currentCreateRouteItinerary = result;
      }else{
        data = result;
      }
    })
  }

  openActionModal(action:string, data?:ItineraryAttributes){
    const dialogRef = this.dialog.open(ActionModalComponent, {
      panelClass: ".form-modal-interlocutor",
      data: action == 'create' ? this.currentCreateRouteItinerary : data,
      width: "500px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(action == 'create'){
        this.currentCreateRouteItinerary = result;
      }else{
        data = result;
      }
    })
  }

  getDayNames(day: number): string {
    const foundDay = this.daysList.find((d) => d.value === day);
    return foundDay ? foundDay.day : "";
  }

  private initializeCreateSubRouteItineraryV2(): ICreateRoutingItinerary {
    return {
        type: null,
        subRouteId: null,
        dateTimeStart: new Date(),
        dateTimeEnd: new Date(),
        detail:[]
    };
  }
 
  removeAction(action: string, element?): void {
    if(element){
      element.action = element.action.filter(a => a !== action);
    }else{
      this.currentCreateRoutingItineraryActions = this.currentCreateRoutingItineraryActions.filter(a => a !== action);
    }
  }

  removeActionAlternative(action: string, element?): void {
    if(element){
      element.action = element.action.filter(a => a !== action);
    }else{
      this.currentCreateRoutingItineraryAlternativeActions = this.currentCreateRoutingItineraryAlternativeActions.filter(a => a !== action);
    }
  }

  onActionSelectionChange(event: MatSelectChange, element?): void {
    const currentValues = event.value as string[];
    const previousValues = element ? element.action : this.currentCreateRoutingItineraryActions;

    const added = currentValues.find(v => !previousValues.includes(v));
    const removed = previousValues.find(v => !currentValues.includes(v));
    
    if (added) {
      if(element){
        element.action = [...previousValues, added];
      }else{
        this.currentCreateRoutingItineraryActions = [...previousValues, added];
      }
    }

    if (removed) {
      if(element){
        element.action = previousValues.filter(v => v !== removed);
      }else{
        this.currentCreateRoutingItineraryActions = previousValues.filter(v => v !== removed);
      }
    }
  }

  onActionAlternativeSelectionChange(event: MatSelectChange, element?): void {
    const currentValues = event.value as string[];
    const previousValues = element ? element.action : this.currentCreateRoutingItineraryAlternativeActions;

    const added = currentValues.find(v => !previousValues.includes(v));
    const removed = previousValues.find(v => !currentValues.includes(v));
    
    if (added) {
      if(element){
        element.action = [...previousValues, added];
      }else{
        this.currentCreateRoutingItineraryAlternativeActions = [...previousValues, added];
      }
    }

    if (removed) {
      if(element){
        element.action = previousValues.filter(v => v !== removed);
      }else{
        this.currentCreateRoutingItineraryAlternativeActions = previousValues.filter(v => v !== removed);
      }
    }
  }

  dropAction(event: CdkDragDrop<string[]>, element?: any): void {
    if(element){
      moveItemInArray(element.action, event.previousIndex, event.currentIndex);
    }
    else{
      moveItemInArray(this.currentCreateRoutingItineraryActions, event.previousIndex, event.currentIndex);
    }
  }

  dropActionAlternative(event: CdkDragDrop<string[]>, element?: any): void {
    if(element){
      moveItemInArray(element.action, event.previousIndex, event.currentIndex);
    }
    else{
      moveItemInArray(this.currentCreateRoutingItineraryAlternativeActions, event.previousIndex, event.currentIndex);
    }
  }

  async toggleDetails(itinerary: RoutingItineraryAttributes): Promise<void> {
    if (this.selectedItinerary && this.selectedItinerary._id === itinerary._id) {
      this.closeDetails();
      return;
    }

    this.selectedItinerary = itinerary;
    this.listItineraryDetail = this.selectedItinerary.detail && this.selectedItinerary.detail.length > 0 ? this.selectedItinerary.detail : [];

  }

  async toggleDetailsAlternative(itineraryA: RoutingItineraryAttributes): Promise<void> {
    if (this.selectedItineraryAlternative && this.selectedItineraryAlternative._id === itineraryA._id) {
      this.closeDetailsAlternative();
      return;
    }

    this.selectedItineraryAlternative = itineraryA;
    this.listItineraryAlternativeDetail = this.selectedItineraryAlternative.detail && this.selectedItineraryAlternative.detail.length > 0 ? this.selectedItineraryAlternative.detail : [];

  }

  closeDetails(): void {
    this.selectedItinerary = null;
  }

  closeDetailsAlternative(): void {
    this.selectedItineraryAlternative = null;
  }

  addItinerary(type){
    const dialogRef = this.dialog.open(RoutingItinerary, {
      panelClass: ".form-modal-interlocutor",
      data: { type: type, subRouteId: this.data._id },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(type == 3){
          this.getRoutingItineraryByType(RoutingItineraryTypesEnum.ROUTE_GROUP);
        }else{
          this.getRoutingItineraryByType(RoutingItineraryTypesEnum.ROUTE_GROUP_ALTERNATIVE)
        }
      }
    });
  }

  onUpdateItinerary(element, i){
    element.isEditMode = true;
  }

  onSaveItinerary(element, type, index){
    if(element.dateTimeStart == null || element.dateTimeStart == '' || element.dateTimeEnd == null || element.dateTimeEnd == '' ){
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    element.isEditMode = false;
    this.updateItinerary(element, type)
  }

  updateItinerary(result, type: number): void {
    if (type === 3) {
      this.routingItineraryService
        .update(
          result._id.toString(),
          result
        )
        .subscribe({
          next: () => {
            this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
              duration: 5000,
              verticalPosition: "top",
            });
            this.getRoutingItineraryByType(RoutingItineraryTypesEnum.ROUTE_GROUP);
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar el registro",
              "Cerrar",
              { duration: 5000, verticalPosition: "top" }
            );
          },
        });
    } else if (type === 4) {
      this.routingItineraryService
        .update(
          result._id.toString(),
          result
        )
        .subscribe({
          next: () => {
            this.snackBar.open(
              "Itinerario Alternativo actualizado con éxito",
              "Cerrar",
              { duration: 5000, verticalPosition: "top" }
            );
            this.getRoutingItineraryByType(RoutingItineraryTypesEnum.ROUTE_GROUP_ALTERNATIVE)
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message ||
                "Error al actualizar el itinerario alternativo",
              "Cerrar",
              { duration: 5000, verticalPosition: "top" }
            );
          },
        });
    }
  }

  openDeleteItinerary(item: any, type): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteItinerary(item, type));
  }

  deleteItinerary(item: any, type): void {
    this.routingItineraryService
      .remove(
        item._id.toString(),
      )
      .subscribe(() => {
        this.snackBar.open("Itinerario eliminado con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        if(type==3){
          this.getRoutingItineraryByType(RoutingItineraryTypesEnum.ROUTE_GROUP);
        } else {
          this.getRoutingItineraryByType(RoutingItineraryTypesEnum.ROUTE_GROUP_ALTERNATIVE);
        }
      });
  }

  openDeleteItineraryAlternative(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteItineraryAlternative(item));
  }

  deleteItineraryAlternative(item: any): void {
    this.routingItineraryService
      .remove(
        item._id.toString(),
      )
      .subscribe(() => {
        this.snackBar.open("Itineario eliminada con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.getRoutingItineraryByType(RoutingItineraryTypesEnum.ROUTE_GROUP_ALTERNATIVE)
      });
  }
  
  onAddToListRoutingItinerary(type){

    if(type == 3){
      if(this.currentCreateRoutingItineraryDay == null || this.currentCreateRoutingItineraryActions.length == 0){
        this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
        return;
      }
      
      if(this.dayAlreadyExists(this.selectedItinerary.detail, this.currentCreateRoutingItineraryDay)){
        this.snackBar.open("El día ya existe en la lista", "Cerrar", {duration: 5000, verticalPosition: "top"});
        return;
      }
    } else {
      if(this.currentCreateRoutingItineraryAlternativeDay == null || this.currentCreateRoutingItineraryAlternativeActions.length == 0){
        this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
        return;
      }
      
      if(this.dayAlreadyExists(this.selectedItineraryAlternative.detail, this.currentCreateRoutingItineraryAlternativeDay)){
        this.snackBar.open("El día ya existe en la lista", "Cerrar", {duration: 5000, verticalPosition: "top"});
        return;
      }
    }

    let detailToAdd:RoutingItineraryDetailAttributes = {
      day: null,
      action: null,
    }

    if(type == 3){

      detailToAdd.day = this.currentCreateRoutingItineraryDay
      detailToAdd.action = this.currentCreateRoutingItineraryActions

      this.listItineraryDetail.push(detailToAdd)
      this.selectedItinerary.detail = this.listItineraryDetail;

      this.orderDaysArray(this.selectedItinerary.detail)
      this.updateItinerary(this.selectedItinerary, type)

      this.openFormAddRoutingItineraryDetail = false;
      this.currentCreateRoutingItineraryDay = null;
      this.currentCreateRoutingItineraryActions = [];

    }else{
      detailToAdd.day = this.currentCreateRoutingItineraryAlternativeDay
      detailToAdd.action = this.currentCreateRoutingItineraryAlternativeActions

      this.listItineraryAlternativeDetail.push(detailToAdd)
      this.selectedItineraryAlternative.detail = this.listItineraryAlternativeDetail;

      this.orderDaysArray(this.selectedItineraryAlternative.detail)
      this.updateItinerary(this.selectedItineraryAlternative, type == 3 ? 3 : 4)

      this.openFormAddRoutingItineraryAlternativeDetail = false;
      this.currentCreateRoutingItineraryAlternativeDay = null;
      this.currentCreateRoutingItineraryAlternativeActions = [];
    }
  }

  orderDaysArray(array){
    array.sort((a, b) => a.day - b.day);
  }

  dayAlreadyExists(array, day){
    return array.some(item => item.day === day)
  }

  openDeleteDetailItinerary(element, index): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: element,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if(result){
          this.listItineraryDetail.splice(index, 1);
          this.orderDaysArray(this.selectedItinerary.detail)
        }
      });
  }

  openDeleteDetailItineraryAlternative(element, index){
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: element,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if(result){
          this.listItineraryAlternativeDetail.splice(index, 1);
          this.orderDaysArray(this.selectedItineraryAlternative.detail)
        }
      });
  }

  onitineraryStatusChange(event: boolean, routingItinerary: RoutingItineraryAttributes): void {
    const updatedStatusId = event ? 1 : 0;
    
    routingItinerary.statusId = updatedStatusId;
    this.updateItinerary(routingItinerary, 3)
  }

  onitineraryAlternativeStatusChange(event: boolean, routingItinerary: RoutingItineraryAttributes): void {
    const updatedStatusId = event ? 1 : 0;
    
    routingItinerary.statusId = updatedStatusId;
    this.updateItinerary(routingItinerary, 4)
  }

  onUpdateDetailItinerary(element, i){
    this.openFormAddRoutingItineraryDetail = false;
    this.editDetailRoutingItineraryDetail = true;
  }

  onUpdateDetailItineraryAlternative(element, i){
    this.openFormAddRoutingItineraryAlternativeDetail = false;
    this.editDetailRoutingItineraryAlternativeDetail = true;
  }

  onSaveDetailItinerary(type){

    if(type == 3){
      if(this.listItineraryDetail.length == 0){
        this.snackBar.open("Ingrese un registro", "Cerrar", {duration: 5000, verticalPosition: "top"});
        return;
      }
  
      if(!this.listItineraryDetail.every(item => item.day !== null && item.action.length > 0)){
        this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
        return;
      }
  
      this.editDetailRoutingItineraryDetail = false;
  
      this.orderDaysArray(this.selectedItinerary.detail)
      this.updateItinerary(this.selectedItinerary, type == 3 ? 3 : 4)
    } else {
      if(this.listItineraryAlternativeDetail.length == 0){
        this.snackBar.open("Ingrese un registro", "Cerrar", {duration: 5000, verticalPosition: "top"});
        return;
      }
  
      if(!this.listItineraryAlternativeDetail.every(item => item.day !== null && item.action.length > 0)){
        this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
        return;
      }
  
      this.editDetailRoutingItineraryAlternativeDetail = false;
  
      this.orderDaysArray(this.selectedItineraryAlternative.detail)
      this.updateItinerary(this.selectedItineraryAlternative, type == 3 ? 3 : 4)
    }
  }
}
